import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ExpenseCreateScreen';
import ExpenseCreate from './ExpenseCreateScreen';
import { StoreState } from 'src/store/reducers';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.expenses.inProgress,
        providers: state.providers.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProviders: (params) => dispatch(getProvidersSmall(params)),
    };
}

const ExpenseCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ExpenseCreate);

export default ExpenseCreateScreen;
